import {
  EyeIcon,
  TrashIcon,
  PencilSquareIcon,
  CheckCircleIcon,
  XCircleIcon,
  MapPinIcon,
  GlobeAltIcon,
  EnvelopeIcon,
  PhoneIcon,
} from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import ConfirmDeleteModal from "../../component/sharedComponents/ConfirmDeleteModal";
import Pagination from "../../component/sharedComponents/Pagination";
import { deleteCompany, getAllCompaniesAdmin, toggleCompanyActive, toggleCompanyVerification } from "../../slices/7-company/thunk";
import CreateCompanyModal from "../../component/SettingsCompanyPage/CreateCompanyModal";
import avatar from "../../assets/images/Avater1.png"
import MainButton from "../../component/sharedComponents/MainButton";
import EditCompanyModal from "../../component/SettingsCompanyPage/EditCompanyModal";
import SectionLoader from "../../component/sharedComponents/Loading/SectionLoader";
const SettingsCompanyPage = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { companies, pagination, loading } = useSelector((state) => state.company);
  const { query, filter } = useSelector((state) => state.search);
  const locale = i18n.language === "ar" ? "ar" : "en";

  const [deleteTarget, setDeleteTarget] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const openCreateModal = () => setIsCreateModalOpen(true);
  const closeCreateModal = () => setIsCreateModalOpen(false);


  useEffect(() => {
    dispatch(getAllCompaniesAdmin({ page: 1, limit: 10 }));
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      getAllCompaniesAdmin({
        page: 1,
        limit: 10,
        search: query,
      })
    );
  }, [query, filter, dispatch]);



  const handleToggleActive = (id) => {
    dispatch(toggleCompanyActive(id));
  };

  const openDeleteModal = (company) => {
    setDeleteTarget(company);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setDeleteTarget(null);
    setIsDeleteModalOpen(false);
  };

  const confirmDelete = (companyId) => {
    dispatch(deleteCompany(companyId));
    closeDeleteModal();
  };

  const handlePageChange = (page) => {
    dispatch(getAllCompaniesAdmin({ page, limit: 10 }));
  };
  const handleToggleVerification = (id) => {
    // console.log(id)
    dispatch(toggleCompanyVerification(id));
  };

  const openEditModal = (company) => {
    setSelectedCompany(company);
    setIsEditOpen(true);
  };

  const closeEditModal = () => {
    setSelectedCompany(null);
    setIsEditOpen(false);
  };


  // console.log(companies)
  return (
    <div className="w-full space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold">{t("companies.title")}</h1>
        <MainButton
          onClick={openCreateModal}
        // className="px-4 py-2 text-white bg-green-500 rounded-lg"
        >
          + {t("companies.add")}
        </MainButton>
      </div>

      {/* Company Cards */}
      <div className="space-y-6">
        {loading ? <SectionLoader /> : companies?.length === 0 ? (
          <p className="text-center text-gray-400">{t("NotFound")}</p>
        ) : (
          companies.map((company) => (
            <div
              key={company?.id}
              className="relative p-6 transition-all duration-300 border rounded-2xl border-border-dark dark:bg-bg-dark-secondary bg-bg-light-secondary hover:shadow-glow"
            >
              {/* Top Right Actions */}
              <div className="absolute flex gap-1 lg:gap-3 top-3 lg:top-4 ltr:right-4 rtl:left-4 ">
                <button onClick={() => openEditModal(company)}
                  title={t("companies.edit")}
                >
                  <PencilSquareIcon className="w-5 h-5 text-yellow-600 transition lg:h-7 lg:w-7 hover:scale-110" />
                </button>

                {/* Toggle Active */}
                <button
                  onClick={() => handleToggleActive(company?.id)}
                  title={
                    company?.isActive
                      ? t("companies.deactivate")
                      : t("companies.activate")
                  }
                  className={`
    flex items-center gap-1 lg:gap-2 lg:px-4 px-2 py-1 lg:py-2 rounded-xl text-xs lg:text-sm font-medium
    transition-all duration-300
    ${company?.isActive
                      ? "bg-green-500/10 text-green-600 hover:bg-green-500/20"
                      : "bg-red-500/10 text-red-600 hover:bg-red-500/20"
                    }
  `}
                >
                  {company?.isActive ? (
                    <>
                      <CheckCircleIcon className="w-4 h-4 lg:h-5 lg:w-5" />
                      {t("companies.active")}
                    </>
                  ) : (
                    <>
                      <XCircleIcon className="w-4 h-4 lg:h-5 lg:w-5" />
                      {t("companies.inactive")}
                    </>
                  )}
                </button>


                {/* Toggle Verification */}
                <button
                  onClick={() => handleToggleVerification(company?.id)}
                  title={
                    company?.isVerified
                      ? t("companies.unverify")
                      : t("companies.verify")
                  }
                  className={`
    flex items-center gap-1 lg:gap-2 lg:px-4 px-2 py-1 lg:py-2 rounded-xl text-xs lg:text-sm font-medium
    transition-all duration-300
    ${company?.isVerified
                      ? "bg-blue-500/10 text-blue-600 hover:bg-blue-500/20"
                      : "bg-gray-500/10 text-gray-600 hover:bg-gray-500/20"
                    }
  `}
                >
                  {company?.isVerified ? (
                    <>
                      <CheckCircleIcon className="w-4 h-4 lg:h-5 lg:w-5" />
                      {t("companies.verified")}
                    </>
                  ) : (
                    <>
                      <XCircleIcon className="w-4 h-4 lg:h-5 lg:w-5" />
                      {t("companies.notVerified")}
                    </>
                  )}
                </button>


                <button onClick={() => openDeleteModal(company)}
                  title={t("companies.delete")}
                >
                  <TrashIcon className="w-5 h-5 text-red-500 lg:h-7 lg:w-7" />
                </button>
              </div>

              <div className="flex gap-6">
                {/* Logo */}
                <div className="flex items-center justify-center w-24 h-24 lg:w-2/12 lg:h-auto rounded-xl max-w-[175px]">
                  <img
                    src={company?.logo || avatar}
                    alt={company?.name_EN}
                    className="object-contain w-full rounded-xl"
                  />
                </div>

                {/* Content */}
                <div className="flex flex-col justify-between w-full py-5 lg:py-6 lg:w-10/12">
                  {/* Name */}
                  <div>
                    <h2 className="mb-2 text-xl font-semibold text-black lg:mb-4 lg:text-2xl dark:text-white">
                      {locale === "ar" ? company?.name_AR : company?.name_EN}
                    </h2>
                    <p className=" dark:text-text-muted-dark text-text-muted-light">
                      {locale === "ar" ? company?.short_bio_AR : company?.short_bio_EN}
                    </p>
                  </div>

                  {/* Category */}
                  {/* {company?.category && (
                    <span className="inline-block px-3 py-1 text-xs text-gray-300 rounded-lg bg-bg-dark-tertiary">
                      {company?.category}
                    </span>
                  )} */}

                  {/* Contact Info Row */}
                  <div className="flex flex-col items-center w-full gap-4 pt-2 text-sm lg:flex-row text-text-muted-dark">
                    {company?.contactInfo?.phone && (
                      <a
                        href={`tel:${company.contactInfo.phone}`}
                        className="flex items-center w-full gap-1 transition duration-300 lg:w-1/4 dark:hover:text-primary hover:text-primary-light"
                      >
                        <PhoneIcon className="w-4 h-4 lg:w-6 lg:h-6 rtl:-rotate-90 " />
                        <span>{company.contactInfo.phone}</span>
                      </a>
                    )}

                    {company?.contactInfo?.email && (
                      <a
                        href={`mailto:${company.contactInfo.email}`}
                        className="flex items-center w-full gap-1 transition duration-300 lg:w-1/4 dark:hover:text-primary hover:text-primary-light"
                      >
                        <EnvelopeIcon className="w-5 h-5 lg:w-7 lg:h-7" />
                        <span>{company.contactInfo.email}</span>
                      </a>
                    )}

                    {company?.contactInfo?.website && (
                      <a
                        href={
                          company.contactInfo.website.startsWith("http")
                            ? company.contactInfo.website
                            : `https://${company.contactInfo.website}`
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center w-full gap-1 transition duration-300 lg:w-1/4 dark:hover:text-primary hover:text-primary-light"
                      >
                        <GlobeAltIcon className="w-5 h-5 lg:w-7 lg:h-7" />
                        <span className="underline">{company.contactInfo.website}</span>
                      </a>
                    )}

                    {company?.contactInfo?.address && (
                      <a
                        href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                          company.contactInfo.address
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center w-full gap-1 transition duration-300 lg:w-1/4 dark:hover:text-primary hover:text-primary-light"
                      >
                        <MapPinIcon className="w-5 h-5 lg:w-7 lg:h-7" />
                        <span>{company.contactInfo.address}</span>
                      </a>
                    )}

                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>




      {/* Pagination */}
      {pagination && companies?.length > 0 && (
        <Pagination
          pagination={pagination}
          onPageChange={(page) => handlePageChange(page)}
        />
      )}

      {/* Delete Modal */}
      {deleteTarget && (
        <ConfirmDeleteModal
          isOpen={isDeleteModalOpen}
          onClose={closeDeleteModal}
          onConfirm={() => confirmDelete(deleteTarget.id)}
          post={deleteTarget}
        />
      )}

      <CreateCompanyModal isOpen={isCreateModalOpen} onClose={closeCreateModal} />
      {selectedCompany && (
        <EditCompanyModal
          isOpen={isEditOpen}
          onClose={closeEditModal}
          company={selectedCompany}
        />
      )}
    </div>
  );
};

export default SettingsCompanyPage;
